import { DialogUI } from '../Interface';
import { useEffect } from 'react';
import { useProject } from '../../hooks/useProject';
import { ProjectPage } from './ProjectPage';

const ProjectEditDialog = ({ handleClose, changed, dialogData }) => {
  const { open, data } = dialogData;
  const { taskChanged, setTaskChanged } = changed;
  const projectState = useProject();

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      projectState.setSelectedValues(data);
    }
  }, [data, projectState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={data.projectName}
      closeBtn
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1500px',
            mx: 1,
          },
        },
        '& .MuiDialogContent-root': {
          px: 0.5,
        },
      }}
    >
      <div className="mt-5">
        <ProjectPage
          dialog={{
            handleClose: handleClose,
            taskChanged: taskChanged,
            setTaskChanged: setTaskChanged,
            isUpdate: true,
          }}
          projectState={projectState}
        />
      </div>
    </DialogUI>
  );
};

export default ProjectEditDialog;
